/* eslint-disable @typescript-eslint/no-explicit-any */
import type { NavigateFunction } from 'react-router-dom'
import type { PlanKey } from '@/hooks/usePlans'
import type { AuthState } from '@/types/backend'

export function routeForPlan(plan: PlanKey) {
  return `/pricing?plan=${plan}`
}

export async function choosePlan({
  plan,
  userInfo,
  requestPlan,
  navigate,
}: {
  plan: PlanKey
  userInfo: AuthState | null
  requestPlan: (plan: PlanKey) => Promise<any>
  navigate: NavigateFunction
}) {
  if (userInfo?.user) {
    await requestPlan(plan)
    navigate(`/billing/manual-payment?plan=${encodeURIComponent(plan)}`, {
      replace: true,
    })
    return
  }
  navigate(
    `/login?redirect=${encodeURIComponent(
      `/billing/manual-payment?plan=${plan}`
    )}&plan=${plan}`
  )
}
